import { Component, ComponentFactoryResolver, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DtmService } from 'src/app/services/dtm.service';
import { HeaderContent } from 'src/app/shared/model/headerContent';
import { NutritionTable } from 'src/app/shared/model/nutrition-table';
import { ShopWindowItem } from 'src/app/shared/model/shop-window-item';
import { ShopWindowManager } from 'src/app/shared/model/shop-window-manager';
import { CatalogService } from 'src/app/shared/services/catalog.service';
import { DiscountModalService } from 'src/app/shared/services/discount-modal.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { ShopWindowService } from 'src/app/shared/services/shop-window.service';
import { packageSuggestionModalDisplayLogService } from 'src/app/shared/services/packageSuggestionModalDisplayLog.service';
import { Dtm, getDtm } from 'src/app/shared/enum/dtm';
import { ShopWindow } from 'src/app/shared/model/shop-window';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { environment } from 'src/environments/environment';
import { SuggestionProductModalComponent } from 'src/app/shared/components/suggestion-product-modal/suggestion-product-modal.component';
import { OneClickPurchaseInfo } from 'src/app/shared/model/one-click-purchase-info';
import { OneClickPurchaseComponent } from 'src/app/shared/components/one-click-purchase/one-click-purchase.component';

const PRODUCT_CLASSIFICATION = 'plano-mensal-recarga-pontual';

@Component({
    selector: 'pme-recarga-pontual-shop-window',
    templateUrl: './recarga-pontual-shop-window.component.html',
    styleUrls: ['./recarga-pontual-shop-window.component.scss'],
    standalone: false
})
export class RecargaPontualShopWindowComponent implements OnInit {


  //Variáveis de conteúdo do Shop Window
  headerContent: HeaderContent;
  tableNutritionContent: NutritionTable;
  packages: Array<ShopWindowItem> = [];
  plans: Array<ShopWindowItem> = [];

  // Variáveis de query params
  coupon: any;
  userId: any;
  businessId: any;
  ref: string;
  internalReference: any;
  checksum: any;
  checksumData: { ref: any; internalReference: any; cs: any; };
  isHybridPackage: boolean;

  classificationsGetted: number = 0;
  hasSelectedPackage: boolean;
  purchaseOrigin: string;
  submitting: boolean;
  sugestionModalDataProducts: any;
  openModalSuggestionFlag: any;


  constructor(
    public catalogService: CatalogService,
    public packageSuggestionModalDisplayLogService: packageSuggestionModalDisplayLogService,
    private discountModalService: DiscountModalService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public dtmService: DtmService,
    public dialog: MatDialog,
    private elementRef: ElementRef,
    private cookieService: CookieService,
    private shopWindowService: ShopWindowService,
    private resolver: ComponentFactoryResolver
  ) {

    this.openDialogSpinner();

    this.clearStorage();

    this.getParameters();

    this.dtmService.customLoaded([]);
    this.dtmService.pageLoaded(Dtm.MeuPacote, this.sessionStorageService.getIsLogged(), getDtm(Dtm.MeuPacote, PRODUCT_CLASSIFICATION));
    this.dtmService.sendPageLoadEvent();


    const validatedMitigation = this.sessionStorageService.getValidatedMitigation();

    this.getProducts(PRODUCT_CLASSIFICATION, validatedMitigation, (items: ShopWindowItem[]) => {
      this.packages = items;
      this.handleProductsLoadDtm();
      this.closeDialogSpinner();
    });
  }

  handleProductsLoadDtm() {
    this.dtmService.productsLoaded(
      this.packages.map((plan) => (
        { 'classificationName': plan.product.classificationName, 'identifier': plan.product.identifier ,'totalValue': plan.product.value }))
    );

    this.dtmService.customLoaded(['ProdImpression', 'OverlayImpression']);
    this.dtmService.ruleChange('ProdImpression');
    this.dtmService.sendPageLoadEvent('ProdImpression');

  }

  getProducts(classification: string, validatedMitigation: any, callback: (items: ShopWindowItem[]) => void): void {
    this.catalogService
      .getProductsByClassification(classification, this.userId, validatedMitigation, this.coupon, this.businessId, this.checksumData
      )
      .subscribe(
        (shopWindow: ShopWindow) => {
          callback(shopWindow.shopWindowItems);
        },
        (error) => {
          throw new Error(
            `Erro ao obter produtos da classificação ${classification}: ${error.message}`,
          );
        },
      );
  }

  clearStorage() {
    this.sessionStorageService.clearSessionStorage(['oneClickPurchase']);
    this.sessionStorageService.clearSessionStorage(['purchaseOrigin']);
    this.sessionStorageService.clearSessionStorage(['oneClickPurchaseData']);
  }

  getParameters() {
    this.getProvisioningParametersFromSessionStorage();

    this.route.queryParams.subscribe((params) => {
      this.coupon = params.coupon;
      if (this.coupon) {
        sessionStorage.setItem('coupon', this.coupon);
      }
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
        this.setProvisioningParametersOnSessionStorage();
      }

      if (params.redirectUrl) {
        sessionStorage.setItem('successRedirectUrl', params.redirectUrl);
      }

      // Obtem parametros de checksum
      if (params.cs) {
        if (params.ref) {
          try {
            // Obtem user e business id do parametro ref em base64
            this.ref = atob(params.ref);
            const [refUserId, refBusinessId] = this.ref.split(':');

            if (refUserId) {
              this.userId = refUserId;
            }
            if (refBusinessId) {
              this.businessId = refBusinessId;
            }
            this.setProvisioningParametersOnSessionStorage();
          } catch (err) { }

        }

        if (params.internalReference) {
          this.internalReference = params.internalReference;
        }

        this.checksum = params.cs;
        this.checksumData = {
          ref: this.ref,
          internalReference: this.internalReference,
          cs: this.checksum
        };

        // Remove query params
        this.router.navigate([], {
          queryParams: {
            'cs': null,
            'ref': null,
            'internalReference': null
          },
          queryParamsHandling: 'merge'
        });
      }
    });

    this.isHybridPackage = this.cookieService.get('subscriptionPlansType') ? true : false;
  }

  ngOnInit(): void {
    this.loadShopWindowContent();
    this.discountModalService.discountModalConfig.subscribe((newDiscountModalConfig) => {
      try {
        let discountModalConfig = JSON.parse(newDiscountModalConfig);
        if (discountModalConfig && discountModalConfig.timeToActivateShopWindow) {
          setTimeout(() => {
            //Impede o cenário que o cliente navegou para o pagamento sem ter ficado os 30 segundos na vitrine
            if (this.router.url.indexOf('meu-pacote') > -1) {
              this.discountModalService.setReachedTheModalTime(true);
            }

          }, discountModalConfig.timeToActivateShopWindow * 1000);
          //verificar f5 comportamento do reachedTheTimeModal
        }
      } catch (err) { }

    });
  }

  setProvisioningParametersOnSessionStorage() {
    this.sessionStorageService.setUserIdAndBusinessId(this.userId, this.businessId);

    if (this.userId && this.businessId) {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  loadShopWindowContent() {
    this.shopWindowService.getShopWindow(PRODUCT_CLASSIFICATION).subscribe((shopWindow: any) => {
      let shopWindowManager = new ShopWindowManager(shopWindow);
      this.headerContent = shopWindowManager.header;
      this.tableNutritionContent = shopWindowManager.nutritionTable;
    });
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: '400px',
      panelClass: 'pme-dialog-loading-panel',
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  closeDialogSpinner() {
    this.dialog.closeAll();
  }


  handlePackageClick(i: number, autoClicked = false) {

    let currPackages = this.packages;

    let selectedPackage = currPackages[i] ? currPackages[i] : null;

    if (!selectedPackage || selectedPackage?.disable) {
      const enableProducts = currPackages.filter(pckg => !pckg.disable);
      this.openErrorDialog('productDisabled', enableProducts, currPackages[i].product.identifier);
      this.sessionStorageService.setOneClickPurchase(false);
      this.sessionStorageService.setPurchaseOrigin('');
      return;
    }
    if (selectedPackage && selectedPackage.selected && selectedPackage === currPackages[i]) {
      selectedPackage.selected = false;
    }

    this.hasSelectedPackage = this.packages.some(pack => pack.selected === true);


    // Adobe Analytics
    if (!autoClicked) {
      this.discountModalService.setClickedOnPackages(true);
      this.dtmService.customLoaded(["ProdClick", "OverlayProdClick"]);
      this.dtmService.productsLoaded([{
        classificationName: selectedPackage.product.classificationName,
        identifier: selectedPackage.product.identifier
      }]);
      window.setTimeout(() => '', 500);
      this.dtmService.ruleChange('prodClick');
      this.dtmService.sendPageLoadEvent('prodClick');
    }

  }

  openErrorDialog(dialogData, enableProducts: ShopWindowItem[], productIdentifier) {
    const data = DialogData.fromPreset(dialogData, { enableProducts });
    const content = data.errorMessage;
    const errorDetail = data.errorDetail;

    this.dialog.open(DialogAlertComponent, {
      disableClose: dialogData === 'checksum' ? true : false,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    // Analytics
    this.dtmService.customErrorLoaded(['error'], {
      errorDetail: errorDetail || productIdentifier,
      errorMessage: content,
    });
  }

  navigate(i: number) {
    let currentPackages = this.packages;

    let product = currentPackages[i];

    if (this.purchaseOrigin !== 'oneClickPurchase' && product.suggestion && !this.isHybridPackage) {
      let productSuggestion = currentPackages.find(p => p.product.identifier === product.suggestion.suggestionProductIdentifier);

      if (!productSuggestion) {
        // this.handleSwiperPackageClick(i);
        return;
      };
      this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, PRODUCT_CLASSIFICATION));
      this.dtmService.userLoaded({
        "businessId": this.businessId || null,
        "userId": this.userId || null,
      });
      this.dtmService.suggestionEvent(productSuggestion.product.identifier, product.product.identifier);

      this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
        "businessId": this.businessId || null,
        "userId": this.userId || null,
        "jorneyMappingEvent": "Modal de sugestão exibido"
      });

      if (!this.openModalSuggestionFlag) {
        let dialog = this.dialog.open(SuggestionProductModalComponent, {
          data: {
            product: product,
            suggestion: productSuggestion,
            sameProduct: product.product.identifier === product.suggestion.triggerProductIdentifier
          },
          panelClass: 'pme-suggestion-product-modal-panel',
          autoFocus: true,
          disableClose: false
        });
        this.openModalSuggestionFlag = true;
        dialog.afterClosed().subscribe((result) => {
          this.openModalSuggestionFlag = false;
          if (result?.approveSugestion) {
            this.packageSuggestionModalDisplayLogService.registerPackageSuggestion(this.userId, this.businessId, productSuggestion.product.identifier, true, product.suggestion.discountIdentifier).subscribe();
            this.handlePackageClick(currentPackages.indexOf(productSuggestion));
            this.dtmService.clicksModalSuggestion(productSuggestion.product.identifier, product.product.identifier, 'ACCEPTED');
            this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, PRODUCT_CLASSIFICATION));
            this.dtmService.userLoaded({
              "businessId": this.businessId || null,
              "userId": this.userId || null,
            });
            this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
              "businessId": this.businessId || null,
              "userId": this.userId || null,
              "jorneyMappingEvent": "Sugestão acatada"
            });

            this.sessionStorageService.setPurchaseOrigin('suggestionPackageModal');
          } else {
            if (result?.approveSugestion === false) {
              this.packageSuggestionModalDisplayLogService.registerPackageSuggestion(this.userId, this.businessId, productSuggestion.product.identifier, false, product.suggestion.discountIdentifier).subscribe();
              this.handlePackageClick(currentPackages.indexOf(product));
              this.dtmService.clicksModalSuggestion(productSuggestion.product.identifier, product.product.identifier, 'REJECTED');
              this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, PRODUCT_CLASSIFICATION));
              this.dtmService.userLoaded({
                "businessId": this.businessId || null,
                "userId": this.userId || null,
              });
              this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
                "businessId": this.businessId || null,
                "userId": this.userId || null,
                "jorneyMappingEvent": "Sugestão rejeitada"
              });
            } else {
              this.dtmService.clicksModalSuggestion(productSuggestion.product.identifier, product.product.identifier, 'CLOSED');
              this.dtmService.pageLoaded(Dtm.ExibicaoModalSugestao, this.sessionStorageService.getIsLogged(), getDtm(Dtm.ExibicaoModalSugestao, PRODUCT_CLASSIFICATION));
              this.dtmService.userLoaded({
                "businessId": this.businessId || null,
                "userId": this.userId || null,
              });
              this.dtmService.sendSydleCustomEvent("modalDeSugestao", {
                "businessId": this.businessId || null,
                "userId": this.userId || null,
                "jorneyMappingEvent": "Sugestão ignorada"
              });

              return;
            }
          }
          // Se existe uma targetURL no sessionStorage, usa-a pra navegar
          const targetUrl = sessionStorage.getItem('targetUrl');
          if (targetUrl && targetUrl !== '' && !targetUrl.includes('meu-pacote') && !targetUrl.includes('consulta-e-recuperacao-de-dividas') &&
            !targetUrl.includes('plano-mensal-recarga-pontual')) {
            this.router.navigate([targetUrl]);
          } else if (product.cardTitle === 'Plano Gratuito') {
            let baseURL = '';
            if (environment.production) {
              baseURL = 'https://www.serasaempreendedor.com.br/';
            } else {
              baseURL = 'https://valfenda-frontend-periscope-serasa-empreendedor-stg.apps.internal.appcanvas.net/';
            }
          } else if (!product.disable) {
            this.router.navigate(['../identificacao'], { relativeTo: this.route });
          }
          this.sessionStorageService.setProduct(product.product.identifier);
          this.sessionStorageService.setClassification(product.product.classificationIdentifier);
          this.sessionStorageService.setClassification(product.product.classificationName);
        });
        return;
      }

      this.dtmService.pageLoaded(Dtm.MeuPacote, this.sessionStorageService.getIsLogged(), getDtm(Dtm.MeuPacote, PRODUCT_CLASSIFICATION));
      return;
    }

    this.submitting = true;

    this.handlePackageClick(i);

    this.sessionStorageService.setProduct(product.product.identifier);
    this.sessionStorageService.setClassification(product.product.classificationIdentifier);
    this.sessionStorageService.setClassification(product.product.classificationName);

    // Se existe uma targetURL no sessionStorage, usa-a pra navegar
    const targetUrl = sessionStorage.getItem('targetUrl');
    if (targetUrl && targetUrl !== '' && !targetUrl.includes('meu-pacote') && !targetUrl.includes('consulta-e-recuperacao-de-dividas') &&
      !targetUrl.includes('plano-mensal-recarga-pontual')) {
      this.router.navigate([targetUrl]);
    } else {
      if (!product.disable) {
        this.router.navigate(['../identificacao'], { relativeTo: this.route, queryParamsHandling: 'preserve' });
      }
    }


  }

  getSugestionModalData(products: Array<ShopWindowItem>) {

    products.forEach(product => {
      let productSuggestion = products.find(p => p.product.identifier === (product?.suggestion?.suggestionProductIdentifier ?? null));
      this.sugestionModalDataProducts.push({
        product: product,
        suggestion: productSuggestion,
        sameProduct: product.product.identifier === (productSuggestion?.product?.identifier ?? null)
      });
    });
  }
}
